export class LoginPasswordModel {
    username: any;
    password: any;
}
